"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateServicefloorReducer = exports.createServicefloorReducer = exports.fetchAllServicefloorReducer = exports.fetchServicefloorReducer = exports.clearAllServicefloorState = exports.clearServicefloorState = exports.servicefloorUpdateSlice = exports.servicefloorCreateSlice = exports.servicefloorFetchAllSlice = exports.servicefloorFetchSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const serviceFloorAction_1 = require("./serviceFloorAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.servicefloorFetchSlice = (0, toolkit_1.createSlice)({
    name: 'serviceFloor/fetch',
    initialState: fetchInitialState,
    reducers: {
        clearServicefloorState: (state) => {
            state.loading = false;
            state.error = null;
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(serviceFloorAction_1.fetch.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(serviceFloorAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(serviceFloorAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.servicefloorFetchAllSlice = (0, toolkit_1.createSlice)({
    name: 'serviceFloor/fetchAll',
    initialState: fetchInitialState,
    reducers: {
        clearAllServicefloorState: (state) => {
            state.loading = false;
            state.error = null;
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(serviceFloorAction_1.fetchAll.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(serviceFloorAction_1.fetchAll.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(serviceFloorAction_1.fetchAll.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.servicefloorCreateSlice = (0, toolkit_1.createSlice)({
    name: 'serviceFloor/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(serviceFloorAction_1.create.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(serviceFloorAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(serviceFloorAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.servicefloorUpdateSlice = (0, toolkit_1.createSlice)({
    name: 'serviceFloor/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(serviceFloorAction_1.update.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(serviceFloorAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(serviceFloorAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.clearServicefloorState = exports.servicefloorFetchSlice.actions.clearServicefloorState;
exports.clearAllServicefloorState = exports.servicefloorFetchAllSlice.actions.clearAllServicefloorState;
exports.fetchServicefloorReducer = exports.servicefloorFetchSlice.reducer;
exports.fetchAllServicefloorReducer = exports.servicefloorFetchAllSlice.reducer;
exports.createServicefloorReducer = exports.servicefloorCreateSlice.reducer;
exports.updateServicefloorReducer = exports.servicefloorUpdateSlice.reducer;
